module.exports = __webpack_public_path__ + "img/calendar.4ef06c47.svg";